var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in&amp;out/color-white/crypto/eth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in&out/color-white/crypto/eth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5,0 C58.20975,0 75,16.79025 75,37.5 C75,58.20975 58.209,75 37.5,75 C16.791,75 0,58.21425 0,37.5 C0,16.78575 16.788,0 37.5,0",
    id: "Path",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ethereum-eth-logo",
    transform: "translate(21.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#343434",
    points: "16.9950151 0 16.6235323 1.27617467 16.6235323 38.3045296 16.9950151 38.6793593 33.9895967 28.5195009"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8C8C8C",
    points: "16.9950151 0 0 28.5195009 16.9950151 38.6793593 16.9950151 20.7068218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3C3C3B",
    points: "16.9950151 41.9335828 16.7856496 42.1917988 16.7856496 55.3818597 16.9950151 56 34 31.7789851"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8C8C8C",
    points: "16.9950151 56 16.9950151 41.9335828 0 31.7789851"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#141414",
    points: "16.9950151 38.6793593 33.9895967 28.5195009 16.9950151 20.7068218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#393939",
    points: "0 28.5195009 16.9950151 38.6793593 16.9950151 20.7068218"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.d972f03b4f160f3a66804f6a3ebb4e97.svg";
export { ForwardRef as ReactComponent };